import Vue from 'vue'
import VueRouter from 'vue-router'

import { checkAuth } from "@/services/auth"

import Login from '@/views/Login.vue'
import RecoveryPassword from '@/views/RecoveryPassword.vue'
import Dashboard from '@/views/Dashboard.vue'
import Analytics from '@/views/Analytics.vue'
import ReportPromoSuperAdmin from '@/views/ReportPromoSuperAdmin.vue'
import ReportPromoSuperAdminLegacy from '@/views/ReportPromoSuperAdminLegacy.vue'
import DashboardFake from '@/views/DashboardFake.vue'
import Profile from '@/views/Profile.vue'

const NotFound = { template: "<div>Page not found</div>" }

import fieldsRoutes from './modules/fields.routes'
import centerAdminRoutes from './modules/center-admin.routes'
import centersRoutes from './modules/centers.routes'
import customersRoutes from './modules/customers.routes'
import matchesRoutes from './modules/matches.routes'
import bookingsRoutes from './modules/bookings.routes'
import closuresRoutes from './modules/closures.routes'
import fixedBookingsRoutes from './modules/fixed_bookings.routes'
import transactionsRoutes from './modules/transactions.routes'
import promoCodesRoutes from './modules/promo-codes.routes'
import cancellationsRoutes from './modules/cancellations.routes'
import reviewsRoutes from './modules/reviews.routes'
import promoSaGlobalRoutes from './modules/promo-sa-global.routes'
import pushNotificationsRoutes from './modules/push-notifications.routes'

import pagesRoutes from './modules/cms/pages.routes'

import configurationsRoutes from './modules/settings/configurations.routes'
import featuresRoutes from './modules/settings/features.routes'
import permissionsRoutes from './modules/settings/permissions.routes'
import servicesRoutes from './modules/settings/services.routes'
import sportsRoutes from './modules/settings/sports.routes'
import sportsConfigMasterRoutes from './modules/settings/sports-config-master.routes'
import usersRoutes from './modules/settings/users.routes'
import blacklistRoutes from './modules/blacklist.routes'
import cancellationReasonRoutes from "./modules/settings/cancellation-reason.routes";
import collaboratorsReasonRoutes from "./modules/collaborators.routes";
import matchStatsRoutes from "./modules/match-stats.routes"
import chatbotRoutes from './modules/chatbot.routes';

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/dashboard'
    },
    {
        path: '/login',
        name: 'Login',
        component: Login
    },
    {
        path: '/recovery-password',
        name: 'RecoveryPassword',
        component: RecoveryPassword
    },
    {
        path: '/analytics',
        name: 'Analytics',
        component: Analytics
    },
    {
        path: '/dashboard',
        name: 'Dashboard',
        component: Dashboard
    },
    {
        path: '/report-promo-superadmin',
        name: 'ReportPromoSA',
        component: ReportPromoSuperAdmin
    },
    {
        path: '/report-promo-superadmin-legacy',
        name: 'ReportPromoSALegacy',
        component: ReportPromoSuperAdminLegacy
    },
    {
        path: '/dashboard-fake',
        name: 'DashboardFake',
        component: DashboardFake
    },
    {
        path: '/profile',
        name: 'Profile',
        component: Profile
    },

    ...pagesRoutes,
    ...bookingsRoutes,
    ...cancellationsRoutes,
    ...centersRoutes,
    ...centerAdminRoutes,
    ...configurationsRoutes,
    ...customersRoutes,
    ...matchesRoutes,
    ...featuresRoutes,
    ...fieldsRoutes,
    ...permissionsRoutes,
    ...promoCodesRoutes,
    ...reviewsRoutes,
    ...servicesRoutes,
    ...sportsRoutes,
    ...transactionsRoutes,
    ...usersRoutes,
    ...promoSaGlobalRoutes,
    ...pushNotificationsRoutes,
    ...fixedBookingsRoutes,
    ...closuresRoutes,
    ...blacklistRoutes,
    ...cancellationReasonRoutes,
    ...collaboratorsReasonRoutes,
    ...sportsConfigMasterRoutes,
    ...matchStatsRoutes,
    ...chatbotRoutes,
    { path: "*", component: NotFound }
]

const router = new VueRouter({
    routes
})

router.beforeEach(async (to, from, next) => {
    const publicPages = ['Login', 'RecoveryPassword']
    const authRequired = !publicPages.includes(to.name)

    const isAuthenticated = await checkAuth()

    if (authRequired && !isAuthenticated) {
        // UCAMP-87 plan 9: dopo il login si torna alla pagina richiesta (es. link dal marketing)
        const redirect = to.fullPath && to.fullPath !== '/' ? { redirect: to.fullPath } : undefined
        return next({ name: 'Login', query: redirect })
    }

    if (!authRequired && isAuthenticated && to.name === 'Login') {
        return next({ name: 'Dashboard' })
    }

    next()
})

export default router
